<script>
  import {format} from "date-fns"
  import Stack from "../../../components/layout/Stack.svelte";
  import { derived } from "svelte/store"
  import { useQuery } from "@sveltestack/svelte-query"
  import { getNotificationsContext } from "svelte-notifications";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import Loading from "../../../components/pages/Loading.svelte";
  import Button from "../../../components/button/Button.svelte";
  import SchedulePeriodicExecutionsDialog from "./SchedulePeriodicExecutionsDialog.svelte";

  const ctx = getAutoMpsProjectContext()
  const {addNotification} = getNotificationsContext()

  const executionSchedulesQueryResult = useQuery(`/api/auto-mps/projects/${$ctx.projectId}/settings/execution-schedules`)
  const executionSchedules = derived(executionSchedulesQueryResult, executionSchedulesQueryResult => {
    const schedules = executionSchedulesQueryResult.data?.executionSchedules ?? []
    return schedules.filter(schedule => schedule.cronString)  // remove one-time execution schedules
  })

  async function cancelExecutionSchedule(scheduleId) {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/settings/execution-schedules/${scheduleId}`, {
      method: "DELETE",
    })
    if (response.ok) {
      addNotification({
        text: "定期実行をキャンセルしました。",
        type: "success",
        removeAfter: 4000,
        position: "top-right",
      })
      await $executionSchedulesQueryResult.refetch()
    } else {
      addNotification({
        text: "定期実行のキャンセルに失敗しました。",
        type: "error",
        removeAfter: 4000,
        position: "top-right",
      })
    }
  }

  let executionScheduleInEdit = null
</script>

<Stack direction="vertical">
  {#if $executionSchedulesQueryResult.isLoading}
    <Loading/>
  {:else}
    {#each $executionSchedules as executionSchedule, index}
      <Stack direction="vertical" gap=".5rem">
        <div style="width: 100%; padding: .3rem .5rem; background-color: lightgrey; display: flex; justify-content: space-between">
          <span>
            #{index + 1}
            <span style="color: #333333; font-size: .9rem; margin-left: 1rem;">
              (最終編集: {format(new Date(executionSchedule.editedAt), "yyyy/M/d HH:mm")})
            </span>
          </span>
          <span style="display: flex; gap: .5rem">
            <Button
              type="secondary"
              size="small"
              onClick={() => executionScheduleInEdit = executionSchedule}
            >
              編集する
            </Button>
            <Button
              type="negative"
              size="small"
              onClick={async () => cancelExecutionSchedule(executionSchedule.id)}
            >
              キャンセルする
            </Button>
          </span>
        </div>
        <Stack direction="vertical" gap=".5rem" style="padding-left: 1rem">
          <div>
            実行される計画パラメタ名: {executionSchedule.schedulingParameter}
          </div>
          <div>
            有効期間:
            {format(new Date(executionSchedule.startAt), "yyyy/M/d HH:mm")} ~
            {executionSchedule.stopAt ? format(new Date(executionSchedule.stopAt), "yyyy/M/d HH:mm") : "(なし)"}
          </div>
          <div>
            Cron式: {executionSchedule.cronString}
          </div>
        </Stack>
      </Stack>
    {:else}
      <span>定期実行の設定がありません。</span>
    {/each}
  {/if}
</Stack>
{#if executionScheduleInEdit}
  <SchedulePeriodicExecutionsDialog
    initialValues={JSON.parse(executionScheduleInEdit.originalValues)}
    onClose={() => executionScheduleInEdit = null}
  />
{/if}